import { render } from "./Caroussel.vue?vue&type=template&id=07a372eb"
import script from "./Caroussel.vue?vue&type=script&lang=js"
export * from "./Caroussel.vue?vue&type=script&lang=js"

import "./Caroussel.vue?vue&type=style&index=0&id=07a372eb&lang=css"

import exportComponent from "/Users/alexisbailly/Documents/Programming/Website/vueform/Wealth & Retirement/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__